import {ChatType, ChatStatus} from '../../copilot.enums';
import {ChatState} from '../../copilot.types';
import {PlanCollapseState} from '../../plan/plan.enums';

export default function chatState({
  chatId,
  type,
  isPlanModeEnabled,
}: {
  chatId: string;
  type: ChatType;
  isPlanModeEnabled: boolean;
}): ChatState {
  return {
    id: chatId,
    type,
    title: '',
    isPlanModeEnabled,
    chatItems: [],
    modalWidget: null,
    blockingChatItemId: null,
    informationText: '',
    draftMessage: {
      text: '',
      fileIds: [],
    },
    plan: null,
    status: ChatStatus.Idle,
    isPlanModeToggleOn: false,
    planCollapseState: PlanCollapseState.Expanded,
    contextWindowUsage: 0,
    lastUpdated: new Date().toISOString(),
  };
}
